import axios from 'axios';
import { stringify } from 'qs';

import config from '../Config';

const ShopAPI = axios.create({
  baseURL: `${config.teliaShopUrl || 'https://pood.telia.ee'}/api`,
  timeout: 30000,
  paramsSerializer: {
    serialize: (params) => stringify(params, { arrayFormat: 'repeat' }),
  },
  withCredentials: true,
});

export default ShopAPI;
